import { render, staticRenderFns } from "./PatientCases.vue?vue&type=template&id=7faa8803&scoped=true&"
import script from "./PatientCases.vue?vue&type=script&lang=js&"
export * from "./PatientCases.vue?vue&type=script&lang=js&"
import style0 from "./PatientCases.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PatientCases.vue?vue&type=style&index=1&id=7faa8803&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7faa8803",
  null
  
)

export default component.exports